/**
 * Global vars
 */

// namespace for new functions and migration of old stuff
window.vrnetworld = {
  dots: {},
  player: {},
  countdown: {},
  poll: {},
  comments: {},
  stagedirections: {},
  backend_comments: {},
  ajax: {},
  savethedate: {},
  user: {},
  helper: {},
  websocket: {},
  frontpage: {},
  config: { // stuff that may be overwritten in child themes
    loginRedirect: '/',
    startEventScrollTarget: '#countdown',
    websocketEnabled: true,
    websocketEnabledFor: {
      single_thementag: true,
      mod_comments: true,
      umfrage: true,
      user_fragen: true,
      backend: true,
      frontpage: false,
    },
    websocketSuccess: false,
    useNewPollPlugin: true,
    debug: false,
    simulateZuschauerBubbles: false,
    bubbleLimit: 50,
    poll_id: 0,
    poll_answer_id: '',
    reloadAjaxTime: 15000,
    startTimePreviewImageOffset: 600000,
    startTimeStreamOffset: 0,
    commentActivateOffsetMinutes: 10,
    afterStreamShowPosterOnly: false,
    ajax_reload_debug: false,
    umfrage_bars_visible: false,
    ajax_templates: {
      comment: '<li id="comment-%%COMMENTID%%" data-comment-id="%%COMMENTID%%" data-user-id="%%COMMENTUSERID%%" data-vimeo-timestamp="%%COMMENTVIMEOTIMESTAMP%%" data-votecount="%%COMMENTKARMA%%" data-commenttime="%%COMMENTTIMESTAMP%%" class="comment byuser %%COMMENTCLASS%%"> <article id="div-comment-%%COMMENTID%%" class="comment-body"> <header class="comment-meta"> <div class="comment-weight-container "><span id="comment-weight-value-%%COMMENTID%%">+%%COMMENTKARMA%%&nbsp;</span><span class="vote-up-wrapper"><a data-comment-id="%%COMMENTID%%" class="vote-up icon-plus-negativ" href="#"></a></span><div class="play-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1100{fill:#f60;}.cls-1101{fill:#fff;}</style></defs><title>Play</title><circle class="cls-1100" cx="20" cy="20" r="20"/><polygon class="cls-1101" points="14.55 10.24 31.45 20 14.55 29.75 14.55 10.24"/></svg></div> </div> <div class="comment-author vcard"> <span class="fn" data-initials="%%COMMENTUSERINITIALS%%">%%COMMENTUSERNAME%%</span> </div> <div class="comment-metadata"> <time datetime="%%COMMENTTIMEC%%"><i class="icon-uhr"></i> %%COMMENTTIMEFORMATED%% </time> </div> </header> <div class="comment-content"> %%COMMENTTEXT%% </div> </article> %%COMMENTVIMEOHTML%% <ol class="children"> %%CHILDREN%% </ol></li>',
      zuschauer: '<li class="bubble" data-user-id="%%USERID%%"><div class="quote %%ROLECLASS%%"><cite>%%USERINITIALS%%</cite></div><div class="popup"><div class="user"></div><div class="time"></div><div class="message"></div></div></li>',
      zuschauerComment: '<a href="#%%POPUPID%%" class="bubble %%CLASS%%" data-votecount="%%VOTECOUNT%%" data-user-id="%%USERID%%" data-comment-id="%%COMMENTID%%"><div class="quote"><cite>%%USERINITIALS%%</cite></div><div id="%%POPUPID%%" class="popup"><div class="user">%%USERNAME%%</div><div class="time"><i class="icon-uhr"></i><span>%%COMMENTTIME%%</span></div><div class="message">%%COMMENTMESSAGE%%</div></div></a>',
      commentVimeoPlay: '<div class="play-overlay"><div class="play-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1100{fill:#f60;}.cls-1101{fill:#fff;}</style></defs><title>Play</title><circle class="cls-1100" cx="20" cy="20" r="20"/><polygon class="cls-1101" points="14.55 10.24 31.45 20 14.55 29.75 14.55 10.24"/></svg></div></div>',
      pollHeader: '<div class="row"><div class="col-lg-8 col-md-12 col-sm-12 col-question"><div class="poll-question baloon baloon__blue baloon__marker-left">%%POLLQUESTION%%</div></div><div class="col-lg-4 col-md-12 col-sm-12 col-question-spacer"></div></div><div class="row"><div class="col-lg-4 col-md-12 col-sm-12 col-answer-desc">Bitte wählen Sie eine der Antwort&shy;möglichkeiten zur Abstimmung!</div><div class="col-lg-8 col-md-12 col-sm-12 col-answers"><div id="polls-%%POLLID%%-ans" class="wp-polls-ans"><ul class="wp-polls-ul">',
      pollBody: '<li><button type="button" id="poll-answer-%%POLLANSWERID%%" class="baloon baloon__orange baloon__marker-right btn-poll-answer" data-poll="%%POLLID%%" name="poll_%%POLLID%%" value="%%POLLANSWERID%%">%%POLLANSWER%%</button></li>',
      pollFooter: '</ul></div></div></div><input type="hidden" id="poll_multiple_ans_%%POLLID%%" value="%%POLLMULTIPLE%%">',
      modComment: '<li id="comment-%%COMMENT_ID%%" data-comment-id="%%COMMENT_ID%%" class=" %%COMMENT_HAS_STAGE_DIRECTION%% %%COMMENT_HOT%% %%COMMENT_HIGHLIGHT%% mod-comment swipeout">\n' +
        '     <div class="row swipeout-content item-content">\n' +
        '         <div class="comment-meta col-xs-2">\n' +
        '            <span class="comment-hot glyphicon glyphicon-star" aria-hidden="true"></span>' +
        '            <div class="comment-weight-container"><span class="comment-weight-value" id="comment-weight-value-%%COMMENT_ID%%">' +
        '                +%%COMMENT_KARMA%%&nbsp;</span><span><a data-comment-id="%%COMMENT_ID%%" class="vote-up icon-plus-negativ" href="#"></a></span>' +
        '            </div>' +
        '         </div>' +
        '         <div class="comment-highlight col-xs-2">' +
        '           <a class="btn btn-comment-highlight comment-highlight-enable" title="Auf Zuschauerscreen hervorheben"><i class="dashicons-before dashicons-warning"></i></a>' +
        '           <a class="btn btn-default comment-highlight-disable" title="nicht mehr hervorheben"><i class="dashicons-before dashicons-warning"></i></a>' +
        '         </div>' +
        '         <div class="col-xs-8">' +
        '             <div class="comment-author">\n' +
        '                 %%COMMENT_AUTHOR%%' +
        '             </div>\n' +
        '         <div class="comment-content">' +
        '                 %%COMMENT_CONTENT%%' +
        '         </div>\n' +
        '         </div>\n' +
        '     </div>\n' +
        '     <div class="swipeout-actions-right">\n' +
        '         <a href="#" data-comment-id="%%COMMENT_ID%%" class="swipeout-delete swipeout-overswipe task1 bg-red">Kommentar entfernen</a>' +
        '     </div>\n' +
        '     <div class="comment-stage-directions row">' +
        '       <div class="col-xs-4"></div>' +
        '       <div class="col-xs-8">' +
        '         <div class="sd-label">Regie-Hinweis:</div>' +
        '         <div class="sd-content">%%COMMENT_STAGE_DIRECTION%%</div>' +
        '       </div>' +
        '     </div>\n' +
        '</li>',
      modStageDirection: '<li id="stagedirection-%%POST_ID%%" data-stagedirection-id="%%POST_ID%%" class=" %%POST_HOT%% mod-stagedirection swipeout">\n' +
        '     <div class="row swipeout-content item-content">\n' +
        '         <div class="stagedirection-meta col-xs-2">\n' +
        '            <span class="stagedirection-hot glyphicon glyphicon-star" aria-hidden="true"></span>' +
        '         </div>' +
        '         <div class="col-xs-2">' +
        '              Regiehinweis:       ' +
        '         </div>' +
        '         <div class="col-xs-8">' +
        '         <div class="stagedirection-content">' +
        '                 %%POST_CONTENT%%' +
        '         </div>\n' +
        '         </div>\n' +
        '     </div>\n' +
        '     <div class="swipeout-actions-right">\n' +
        '         <a href="#" data-stagedirection-id="%%POST_ID%%" class="swipeout-delete swipeout-overswipe task1 bg-red">Hinweis entfernen</a>' +
        '     </div>\n' +
        '</li>',
      bbbMeetingRoom: '<div class="row single-bbb">' +
        '<div class="col-xs-3 col1">%%NAME%%</div>' +
        '<div class="col-xs-9 col2"><a class="btn btn-primary" target="_blank" href="%%LINK%%">Konferenzraum betreten</a></div>' +
        '</div>'
    },
    smilies: {
      ':neutral:' : "\xf0\x9f\x98\x90",
      ':twisted:' : "\xf0\x9f\x98\x88",
      ':arrow:'   : "\xe2\x9e\xa1",
      ':shock:'   : "\xf0\x9f\x98\xaf",
      ':smile:'   : "\xf0\x9f\x99\x82",
      ':???:'     : "\xf0\x9f\x98\x95",
      ':cool:'    : "\xf0\x9f\x98\x8e",
      ':evil:'    : "\xf0\x9f\x91\xbf",
      ':grin:'    : "\xf0\x9f\x98\x80",
      ':idea:'    : "\xf0\x9f\x92\xa1",
      ':oops:'    : "\xf0\x9f\x98\xb3",
      ':razz:'    : "\xf0\x9f\x98\x9b",
      ':roll:'    : "\xf0\x9f\x99\x84",
      ':wink:'    : "\xf0\x9f\x98\x89",
      ':cry:'     : "\xf0\x9f\x98\xa5",
      ':eek:'     : "\xf0\x9f\x98\xae",
      ':lol:'     : "\xf0\x9f\x98\x86",
      ':mad:'     : "\xf0\x9f\x98\xa1",
      ':sad:'     : "\xf0\x9f\x99\x81",
      '8-)'       : "\xf0\x9f\x98\x8e",
      '8-O'       : "\xf0\x9f\x98\xaf",
      ':-('       : "\xf0\x9f\x99\x81",
      ':-)'       : "\xf0\x9f\x99\x82",
      ':-?'       : "\xf0\x9f\x98\x95",
      ':-D'       : "\xf0\x9f\x98\x80",
      ':-P'       : "\xf0\x9f\x98\x9b",
      ':-o'       : "\xf0\x9f\x98\xae",
      ':-x'       : "\xf0\x9f\x98\xa1",
      ':-|'       : "\xf0\x9f\x98\x90",
      ';-)'       : "\xf0\x9f\x98\x89",
      '8O'        : "\xf0\x9f\x98\xaf",
      ':('        : "\xf0\x9f\x99\x81",
      ':)'        : "\xf0\x9f\x99\x82",
      ':?'        : "\xf0\x9f\x98\x95",
      ':D'        : "\xf0\x9f\x98\x80",
      ':P'        : "\xf0\x9f\x98\x9b",
      ':o'        : "\xf0\x9f\x98\xae",
      ':x'        : "\xf0\x9f\x98\xa1",
      ':|'        : "\xf0\x9f\x98\x90",
      ';)'        : "\xf0\x9f\x98\x89",
      ':!:'       : "\xe2\x9d\x97",
      ':?:'       : "\xe2\x9d\x93",
          ":grinning:": "\xf0\x9f\x98\x80",
          ":thumbsup:": "\xf0\x9f\x91\x8D",
          ":thumbsdown:"  : "\xf0\x9f\x91\x8E",
          ":clap:"        : "\xf0\x9f\x91\x8F",
          ":partying_face:"   : "\xf0\x9f\xA5\xB3",
          ":champagne_glass:" : "\xf0\x9f\xA5\x82",
    }
  },
  translations: {
    en: {
      "commentlock-failed" : "Failed to lock comment",
      "no-permission-comment" : "You don't have permission to comment.",
      "sending-failed" : "Failed to send. Please try again later.",
      "commmentsupdate-failed" : "Failed to update comments. Please reload page.",
      "no-permission-vote" : "You don't have permission to vote.",
      "already-voted-answer" : "You already voted for this answer.",
      "already-voted" : "You already voted.",
      "entryadd-failed" : "Failed to add your entry. Please try again.",
      "commenthightlight-failed" : "Failed to highlight comment.",
      "commentremove-failed" : "Failed to remove comment.",
      "stage-directionremove-failed" : "Failed to remove stage-direction.",
      "no-permission-commentvote" : "You don't have permission to vote for comments.",
      "already-voted-comment" : "You already voted for this comment.",
      "vote-own-comment" : "You cannot vote for your own comment.",
      "invalid-login-cookie" : "Invalid Login-Cookie",
      "invalid-domain" : "Invalid Domain.",
      "invalid-login" : "Invalid login.",
      "no-permission-page" : "You don't have permissions for this page.",
      "vote-success" : "Thank you for voting.",
      "entryadd-success" : "Your entry was successfully sent.",
      "error" : "Error",
      "notice" : "Notice",
      "warning" : "Warning"
    },
    de: {
      "commentlock-failed" : "Kommentar-Sperrung fehlgeschlagen.",
      "no-permission-comment" : "Sie besitzen keine Berechtigung um zu kommentieren.",
      "sending-failed" : "Absenden fehlgeschlagen, versuchen Sie es bitte erneut.",
      "commmentsupdate-failed" : "Aktualisieren der Kommentare fehlgeschlagen. Bitte laden Sie die Seite neu.",
      "no-permission-vote" : "Sie besitzen keine Berechtigung um abzustimmen.",
      "already-voted-answer" : "Sie haben bereits für diese Antwort gestimmt.",
      "already-voted" : "Sie haben bereits abgestimmt.",
      "entryadd-failed" : "Ihre Eingabe konnte nicht hinzugefügt werden, versuchen Sie es bitte erneut.",
      "commenthightlight-failed" : "Kommentar-Hervorherbung fehlgeschlagen.",
      "commentremove-failed" : "Kommentarentfernung fehlgeschlagen.",
      "stage-directionremove-failed" : "Regie-Hinweis-Entfernung fehlgeschlagen.",
      "no-permission-commentvote" : "Sie besitzen keine Berechtigung um für einen Kommentar zu stimmen.",
      "already-voted-comment" : "Sie haben schon für diesen Kommentar gestimmt.",
      "vote-own-comment" : "Sie können nicht für Ihren eigenen Kommentar stimmen.",
      "invalid-login-cookie" : "Ungültiger Login-Cookie.",
      "invalid-domain" : "Ungültige Domain.",
      "invalid-login" : "Ungültiger Login.",
      "no-permission-page" : "Sie besitzen keine Berechtigungen für diese Seite.",
      "vote-success" : "Vielen Dank für Ihre Stimme.",
      "entryadd-success" : "Ihre Eingabe wurde übernommen.",
      "error" : "Fehler",
      "notice" : "Hinweis",
      "warning" : "Warnung"
    }
  }
};

// compat
var reloadAjaxTime = window.vrnetworld.config.reloadAjaxTime;
var AJAX_RELOAD_DEBUG = window.vrnetworld.config.ajax_reload_debug;
var ajax_templates = window.vrnetworld.config.ajax_templates;

window.getLibObject = function(selector) {
  return window.vrnetworld[selector];
};
